export const IS_LOADING = "IS_LOADING";

export const IS_CHANGE_CONTRY_LOADING = "IS_CHANGE_CONTRY_LOADING";